import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TechnicalData } from '../../entities/technicalData';
import { FileEvent } from 'src/app/+shared/models/fileEvent';
import { NgForm } from '@angular/forms';
import { BaseSectionComponent } from './base-section.component';
import { first } from 'rxjs/operators';
import { EnvironmentService } from 'src/app/services/environment.service';
import { GridApplicationCommentsService } from '../../services/grid-application-comments.service';

@Component({
  selector: 'app-base-section',
  template: '',
})
export abstract class BaseTechnicalSectionComponent extends BaseSectionComponent {
  public readonly downloadCenterLink: string = '&#160;<a href="/download-center" target="_blank">Download Center</a>&#160;';

  @Input() technicalData: TechnicalData;
  @Input() technicalForm: NgForm;

  @Output() changeCommentText = new EventEmitter<string>();

  constructor(protected commentService: GridApplicationCommentsService, protected environmentService: EnvironmentService) {
    super(environmentService);
  }

  public clearFile(fileEvent: FileEvent): void {
    if (!fileEvent.documentId) {
      return;
    }

    if (!this.technicalData.document_ids_for_deletion) {
      this.technicalData.document_ids_for_deletion = [];
    }

    this.technicalData.document_ids_for_deletion.push(fileEvent.documentId);
    this.technicalForm.form.markAsDirty();
  }

  protected async saveComment(): Promise<void> {
    if (this.technicalData.technical_specifications_sections_state.application_id) {
      return await this.commentService
        .updateTechnicalSpecificationsSectionComment(this.technicalData.technical_specifications_sections_state)
        .pipe(first())
        .toPromise();
    }

    this.technicalData.technical_specifications_sections_state.application_id = this.applicationId;
    await this.commentService
      .createTechnicalSpecificationsSectionComment(this.technicalData.technical_specifications_sections_state)
      .pipe(first())
      .toPromise();
  }
}
